import React, { useEffect, useState } from "react";
import { Card, Table, Button, message, Typography, Modal, Row, Col, Spin } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { Link } from "react-router-dom";
import FAQForm from "./FAQForm";

const { Title } = Typography;

const FAQList = () => {
  const [faqs, setFAQs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/faqs");
      setFAQs(response.data);
    } catch (error) {
      message.error("Failed to load FAQs.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://93.127.203.113:5005/faqs/${id}`);
      message.success("FAQ deleted successfully.");
      fetchFAQs();
    } catch (error) {
      message.error("Failed to delete FAQ.");
    }
  };

  const columns = [
    { title: "Question", dataIndex: "question", key: "question" },
    // { title: "Answer", dataIndex: "answer", key: "answer" },

    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} style={{ color: "#0c8c49" }}>
            Edit
          </Button>
          <Link to={`/faqDetails/${record.id}`} style={{ color: "#0c8c49", marginLeft: 10 }}>
            <InfoCircleOutlined /> Details
          </Link>
          <Button type="link" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} danger>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={styles.card}>
        <Title level={4} style={styles.title}>FAQs</Title>

        {/* Row for Add Button */}
        <Row justify="end" style={{ marginBottom: "20px" }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)} style={styles.addButton}>
            Add FAQ
          </Button>
        </Row>

        {/* Table with Loading State */}
        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={faqs} rowKey="id" />}

        {/* Modal for Form */}
        <Modal visible={modalVisible} footer={null} onCancel={() => setModalVisible(false)} destroyOnClose>
          <FAQForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} refetchData={fetchFAQs} />
        </Modal>
      </Card>
    </div>
  );
};

// 🎨 **Styled Components**
const styles = {
  card: {
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "20px",
  },
  title: {
    color: "#0c8c49",
    marginBottom: "20px",
  },
  addButton: {
    backgroundColor: "#0c8c49",
    borderColor: "#0c8c49",
  },
};

export default FAQList;
